module.exports = "//static.hsappstatic.net/visitor-ui-component-library/static-1.2653/img/default-avatar.png"